import { HttpCodes } from '@constants/apiErrors';
import { BANK_TOKEN_URL } from '@constants/config';
import { BankDetails } from '@src/types/requests';

// In dev, requests are routed through the Vite proxy (see vite.config.ts)
// to avoid CORS, since BANK_TOKEN_URL doesn't allow cross-origin requests.
const bankTokenEndpoint = import.meta.env.DEV
  ? '/api/bank-token'
  : BANK_TOKEN_URL;

const fetchBankToken = async (bankDetails: BankDetails) => {
  const response = await fetch(bankTokenEndpoint, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      account_number: bankDetails.accountNumber,
      sortcode: bankDetails.sortCode,
    }),
  });

  const { status } = response;
  const data = await response.json();

  if (status === HttpCodes.badRequest) {
    throw new Error(data.message);
  } else if (!response.ok) {
    throw new Error(
      `fetchBankToken request failed. status: ${response.status}`
    );
  }

  const token = data.token as Nullable<string> | undefined;

  return token ?? null;
};
export { fetchBankToken };
